'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// src/constants/index.ts
var LANG_CODE_ZH = "zh";
var LANG_CODE_EN = "en";
var LANG_CODE_JA = "ja";
var LANG_CODE_TH = "th";
var LANG_CODE_DE = "de";
var LANG_CODE_ES = "es";
var LANG_CODE_FR = "fr";
var LANG_CODE_ID = "id";
var LANG_CODE_PL = "pl";
var LANG_CODE_PT = "pt";
var LANG_CODE_RU = "ru";
var LANG_CODE = {
    zh: LANG_CODE_ZH,
    en: LANG_CODE_EN,
    ja: LANG_CODE_JA,
    th: LANG_CODE_TH,
    de: LANG_CODE_DE,
    es: LANG_CODE_ES,
    fr: LANG_CODE_FR,
    id: LANG_CODE_ID,
    pl: LANG_CODE_PL,
    pt: LANG_CODE_PT,
    ru: LANG_CODE_RU
};
var LANG_TAG_ZH_CN = "zh-CN";
var LANG_TAG_ZH_HK = "zh-HK";
var LANG_TAG_EN_US = "en-US";
var LANG_TAG_JA_JP = "ja-JP";
var LANG_TAG_ZH_HANT = "zh-Hant";
var LANG_TAG_ZH_TW = "zh-TW";
var LANG_TAG_ZH_MO = "zh-MO";
var LANG_TAG_TH_TH = "th-TH";
var LANG_TAG_DE_DE = "de-DE";
var LANG_TAG_ES_ES = "es-ES";
var LANG_TAG_FR_FR = "fr-FR";
var LANG_TAG_ID_ID = "id-ID";
var LANG_TAG_PL_PL = "pl-PL";
var LANG_TAG_PT_PT = "pt-PT";
var LANG_TAG_RU_RU = "ru-RU";
var LANG_TAG_AR_SA = "ar-SA";
var LANG_TAG = {
    zhCN: LANG_TAG_ZH_CN,
    zhHK: LANG_TAG_ZH_HK,
    enUS: LANG_TAG_EN_US,
    jaJP: LANG_TAG_JA_JP,
    zhHant: LANG_TAG_ZH_HANT,
    zhTW: LANG_TAG_ZH_TW,
    zhMO: LANG_TAG_ZH_MO,
    thTH: LANG_TAG_TH_TH,
    deDE: LANG_TAG_DE_DE,
    esES: LANG_TAG_ES_ES,
    frFR: LANG_TAG_FR_FR,
    idID: LANG_TAG_ID_ID,
    plPL: LANG_TAG_PL_PL,
    ptPT: LANG_TAG_PT_PT,
    ruRU: LANG_TAG_RU_RU
};
var LANGS_USE_ZH_HK = [
    LANG_TAG_ZH_HK,
    LANG_TAG_ZH_HANT,
    LANG_TAG_ZH_TW,
    LANG_TAG_ZH_MO
];
var LANGS_SUPPORTED = [
    LANG_TAG_ZH_CN,
    LANG_TAG_ZH_HK,
    LANG_TAG_EN_US,
    LANG_TAG_JA_JP
];
var TOP_DOMAIN = {
    kdocs: ".kdocs.cn",
    wps: ".wps.cn"
};
var ALLOWED_SYNC_TOP_DOMAIN = [
    TOP_DOMAIN.kdocs,
    TOP_DOMAIN.wps
];
var REGION_TAG_CN = "cn";
var REGION_TAG_JP = "jp";
var REGION_TAG_EUR = "eur";
var COA_ID_CN = 0;
var COA_ID_JP = 25;
var COA_ID_EUR = 26;
var _obj;
var COA_ID_REGION_MAP = (_obj = {}, _define_property(_obj, COA_ID_CN, REGION_TAG_CN), _define_property(_obj, COA_ID_JP, REGION_TAG_JP), _define_property(_obj, COA_ID_EUR, REGION_TAG_EUR), _obj);
var getRegionByCoaId = function(coaId) {
    if (!coaId) return REGION_TAG_CN;
    return COA_ID_REGION_MAP[coaId] || REGION_TAG_CN;
};
// src/utils/index.ts
var getCookie = function(cookieString, key) {
    if (!cookieString || !key) return "";
    var match = cookieString.match(new RegExp("(?:^|;\\s*)".concat(key, "=([^;]*)")));
    return match ? match[1] : "";
};
var SAME_SITE_NONE = "none";
var setCookie = function(key, value, options) {
    var _ref = options || {}, domain = _ref.domain, expires = _ref.expires, _ref_path = _ref.path, path = _ref_path === void 0 ? "/" : _ref_path, _ref_secure = _ref.secure, secure = _ref_secure === void 0 ? true : _ref_secure, _ref_sameSite = _ref.sameSite, sameSite = _ref_sameSite === void 0 ? SAME_SITE_NONE : _ref_sameSite;
    var parts = [
        "".concat(key, "=").concat(encodeURIComponent(value)),
        "path=".concat(path),
        "sameSite=".concat(sameSite)
    ];
    if (domain) parts.push("domain=".concat(domain));
    if (expires) {
        var date = /* @__PURE__ */ new Date();
        date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1e3);
        parts.push("expires=".concat(date.toUTCString()));
    }
    if (secure || sameSite === SAME_SITE_NONE) parts.push("secure");
    document.cookie = parts.join("; ");
};
var isObject = function(value) {
    return (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && value !== null;
};
var startWith = function(str, prefix) {
    return new RegExp("^".concat(prefix)).test(str);
};
var isSupportedLang = function(lang, langsSupported) {
    return langsSupported.indexOf(lang) > -1;
};
var getPreferredLanguage = function(acceptLanguage) {
    var _acceptLanguage_split_map_sort_map;
    if (!acceptLanguage) return "";
    return (_acceptLanguage_split_map_sort_map = acceptLanguage.split(",").map(function(lang) {
        var _lang_split = _sliced_to_array(lang.split(";q="), 2), language = _lang_split[0], q = _lang_split[1];
        return {
            language: language.trim(),
            quality: q ? parseFloat(q) : 1
        };
    }).sort(function(a, b) {
        return b.quality - a.quality;
    }).map(function(langObj) {
        return langObj.language;
    })) === null || _acceptLanguage_split_map_sort_map === void 0 ? void 0 : _acceptLanguage_split_map_sort_map[0];
};
var getTopDomain = function() {
    var host = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : location.host;
    if (!host) return "";
    var parts = host.split(".");
    if (parts.length >= 2) {
        return ".".concat(parts.slice(-2).join("."));
    }
    return "";
};
var getHost = function(url) {
    if (!url) return "";
    var match = url.match(/^(?:https?:)?\/\/([^/]+)/);
    return match ? match[1] : "";
};
var isWX = function(userAgent) {
    return userAgent ? /micromessenger/i.test(userAgent) : false;
};
function isPlainObject(item) {
    return isObject(item) && !Array.isArray(item);
}
function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        sources[_key - 1] = arguments[_key];
    }
    if (!sources.length) return target;
    var result = _object_spread({}, target);
    for(var i = 0; i < sources.length; i++){
        var source = sources[i];
        if (!isPlainObject(source)) continue;
        for(var key in source){
            var srcValue = source[key];
            var targetValue = result[key];
            if (isPlainObject(targetValue) && isPlainObject(srcValue)) {
                result[key] = deepMerge(targetValue, srcValue);
            } else if (srcValue !== void 0) {
                result[key] = srcValue;
            }
        }
    }
    return result;
}
// src/get-lang/utils.ts
var getLangFromQuery = function(url) {
    if (!url) return "";
    var match = url.match(/[?&]lang=([^&]+)/);
    return match ? match[1] : "";
};
var formatLangTag = function(lang) {
    return lang.toLowerCase();
};
var compareLangTag = function(target, source) {
    return formatLangTag(target) === formatLangTag(source);
};
var compareLangCode = function(target, source) {
    return startWith(formatLangTag(source), formatLangTag(target).slice(0, 2));
};
var findInLangs = function(lang, langs) {
    var compareFn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : compareLangTag;
    for(var i = 0; i < langs.length; i++){
        if (compareFn(langs[i], lang)) return langs[i];
    }
    return "";
};
var getLangFromCookie = function() {
    var cookieString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return getCookie(cookieString, "lang");
};
var getUsedLang = function(lang, options) {
    var _ref = isObject(options) ? options : {}, _ref_fallback = _ref.fallback, fallback = _ref_fallback === void 0 ? LANG_TAG_ZH_CN : _ref_fallback, _ref_langsSupported = _ref.langsSupported, langsSupported = _ref_langsSupported === void 0 ? LANGS_SUPPORTED : _ref_langsSupported;
    var fullMatched = findInLangs(lang, langsSupported);
    if (fullMatched) return fullMatched;
    var safeFallback = isSupportedLang(fallback, langsSupported) ? fallback : LANG_TAG_ZH_CN;
    var langCompared = formatLangTag(lang);
    var targetLang = safeFallback;
    if (/-hant/.test(langCompared)) {
        targetLang = LANG_TAG_ZH_HK;
    } else if (startWith(langCompared, LANG_CODE_ZH)) {
        var useZhHK = findInLangs(langCompared, LANGS_USE_ZH_HK) && isSupportedLang(LANG_TAG_ZH_HK, langsSupported);
        targetLang = useZhHK ? LANG_TAG_ZH_HK : LANG_TAG_ZH_CN;
    } else {
        var matched = findInLangs(langCompared, langsSupported, compareLangCode);
        if (matched) {
            targetLang = matched;
        }
    }
    return isSupportedLang(targetLang, langsSupported) ? targetLang : safeFallback;
};
var globalLangKey = "$kd_i18n_lang";
var setGlobalLang = function(lang) {
    if (!window) return;
    window[globalLangKey] = lang;
};
var getGlobalLang = function() {
    return window ? window[globalLangKey] : void 0;
};
// src/get-lang/browser.ts
var getLangFromNavigator = function(navigator2) {
    if (!navigator2 || isWX(navigator2.userAgent)) return "";
    return navigator2.language;
};
var getLang = function(options) {
    var _ref = options || {}, _ref_url = _ref.url, url = _ref_url === void 0 ? window.location.href : _ref_url, _ref_cookie = _ref.cookie, cookie = _ref_cookie === void 0 ? document.cookie : _ref_cookie, _ref_fallback = _ref.fallback, fallback = _ref_fallback === void 0 ? LANG_TAG_ZH_CN : _ref_fallback, _ref_langsSupported = _ref.langsSupported, langsSupported = _ref_langsSupported === void 0 ? LANGS_SUPPORTED : _ref_langsSupported;
    try {
        var lang = window.langName || getGlobalLang() || getLangFromQuery(url) || getLangFromCookie(cookie) || getLangFromNavigator(navigator) || fallback;
        return getUsedLang(lang, {
            fallback: fallback,
            langsSupported: langsSupported
        });
    } catch (error) {
        console.error("Get browser lang error", error);
        return fallback;
    }
};
// src/get-lang/server.ts
var getLangFromAcceptLanguage = function() {
    var headers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var acceptLanguage = headers["accept-language"];
    var userAgent = headers["user-agent"];
    if (!acceptLanguage || isWX(userAgent)) return "";
    return getPreferredLanguage(acceptLanguage);
};
var getServerLang = function(options) {
    var _ref = options || {}, url = _ref.url, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers, _ref_fallback = _ref.fallback, fallback = _ref_fallback === void 0 ? LANG_TAG_ZH_CN : _ref_fallback, _ref_langsSupported = _ref.langsSupported, langsSupported = _ref_langsSupported === void 0 ? LANGS_SUPPORTED : _ref_langsSupported;
    try {
        var lang = getLangFromQuery(url) || getLangFromCookie(headers["cookie"]) || headers["x-client-lang"] || getLangFromAcceptLanguage(headers) || fallback;
        return getUsedLang(lang, {
            fallback: fallback,
            langsSupported: langsSupported
        });
    } catch (error) {
        console.error("Get server lang error", error);
        return fallback;
    }
};
// src/set-lang/index.ts
var setLang2Cookie = function(lang) {
    var domain = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getTopDomain();
    try {
        setCookie("lang", lang, {
            expires: 365,
            domain: domain
        });
    } catch (error) {
        console.error("setLang2Cookie error ->", error);
    }
};
var setLang = function() {
    var lang = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : LANG_TAG_ZH_CN, options = arguments.length > 1 ? arguments[1] : void 0;
    var _ref = options || {}, _ref_callbackUrl = _ref.callbackUrl, callbackUrl = _ref_callbackUrl === void 0 ? window.location.href : _ref_callbackUrl, _ref_sync = _ref.sync, sync = _ref_sync === void 0 ? true : _ref_sync, _ref_reload = _ref.reload, reload = _ref_reload === void 0 ? true : _ref_reload;
    var topDomain = getTopDomain();
    var canSync = isAllowedSyncUrl(window.location.href) && sync;
    setLang2Cookie(lang, topDomain);
    if (!reload) return;
    if (!canSync) return window.location.replace(callbackUrl);
    var host = topDomain === TOP_DOMAIN.kdocs ? "docs".concat(TOP_DOMAIN.wps) : "www".concat(TOP_DOMAIN.kdocs);
    var redirectUrl = "https://".concat(host, "/public/set-lang?lang=").concat(lang, "&callback=").concat(encodeURIComponent(callbackUrl));
    window.location.replace(redirectUrl);
};
var isAllowedSyncUrl = function(url) {
    for(var i = 0; i < ALLOWED_SYNC_TOP_DOMAIN.length; i++){
        if (getHost(url).indexOf(ALLOWED_SYNC_TOP_DOMAIN[i]) >= 0) return true;
    }
    return false;
};
var isAllowedUrl = isAllowedSyncUrl;
var getLangUrl = function(urlString, lang) {
    var _urlString_split = _sliced_to_array(urlString.split("#"), 2), urlWithoutHash = _urlString_split[0], tmp = _urlString_split[1], hash = tmp === void 0 ? "" : tmp;
    var withHash = hash ? "#" + hash : "";
    var result = urlWithoutHash;
    if (/[?&]lang=/.test(urlWithoutHash)) {
        result = urlWithoutHash.replace(/([?&])lang=[^&]*/, "$1lang=".concat(lang));
    } else {
        var tag = urlWithoutHash.indexOf("?") > -1 ? "&" : "?";
        result = "".concat(urlWithoutHash).concat(tag, "lang=").concat(lang);
    }
    return result + withHash;
};
var setQueryLang = function(lang, options) {
    var _ref = options || {}, reloadFn = _ref.reloadFn, _ref_callbackUrl = _ref.callbackUrl, callbackUrl = _ref_callbackUrl === void 0 ? window.location.href : _ref_callbackUrl;
    var url = getLangUrl(callbackUrl, lang);
    reloadFn ? reloadFn(url) : window.location.replace(url);
    return url;
};
// src/config/common.ts
function getI18nConfig(options) {
    var defaultConfig = options.defaultConfig, language = options.language, regionConfig = options.regionConfig, languageConfig = options.languageConfig;
    var _languageConfig = languageConfig && language ? languageConfig[language] : {};
    var regionDefaultConfig = regionConfig ? regionConfig["default"] : {};
    var regionLanguageConfig = regionConfig && language ? regionConfig[language] : {};
    return deepMerge(defaultConfig, regionDefaultConfig, _languageConfig, regionLanguageConfig);
}
// src/config/index.ts
var defaultRegionInfo = {
    region: REGION_TAG_CN,
    isOverseas: false
};
var getRegionInfo = function() {
    var href = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var info = _object_spread({}, defaultRegionInfo);
    try {
        var matched = href.match(/(\w+)\.(wps365\.com)/);
        if (matched && matched[1]) {
            info.region = matched[1];
            info.isOverseas = true;
        }
    } catch (error) {}
    return info;
};
var getWebOfficeRegionInfo = function() {
    try {
        return window.__WPSPLUGIN__.pluginMgr.helper.env.getRegionInfo();
    } catch (error) {
        return null;
    }
};
var defaultUserRegionInfo = {
    region: REGION_TAG_CN,
    isCrossRegion: false,
    isOverseas: false
};
var getUserRegionInfo = function(param) {
    var href = param.href, cookie = param.cookie;
    var result = _object_spread({}, defaultUserRegionInfo);
    var webOfficeRegionInfo = getWebOfficeRegionInfo();
    if (webOfficeRegionInfo && webOfficeRegionInfo.userRegion) {
        result.region = webOfficeRegionInfo.userRegion.region_name;
        result.isCrossRegion = webOfficeRegionInfo.isCrossRegion;
    } else {
        var coaId = getCookie(cookie || "", "coa_id");
        var appRegionInfo = getRegionInfo(href);
        var userRegion = getRegionByCoaId(coaId);
        result.region = userRegion;
        result.isCrossRegion = appRegionInfo.region !== userRegion;
    }
    result.region = result.region || REGION_TAG_CN;
    result.isOverseas = result.region !== REGION_TAG_CN;
    return result;
};
exports.ALLOWED_SYNC_TOP_DOMAIN = ALLOWED_SYNC_TOP_DOMAIN;
exports.COA_ID_CN = COA_ID_CN;
exports.COA_ID_EUR = COA_ID_EUR;
exports.COA_ID_JP = COA_ID_JP;
exports.COA_ID_REGION_MAP = COA_ID_REGION_MAP;
exports.LANGS_SUPPORTED = LANGS_SUPPORTED;
exports.LANGS_USE_ZH_HK = LANGS_USE_ZH_HK;
exports.LANG_CODE = LANG_CODE;
exports.LANG_CODE_DE = LANG_CODE_DE;
exports.LANG_CODE_EN = LANG_CODE_EN;
exports.LANG_CODE_ES = LANG_CODE_ES;
exports.LANG_CODE_FR = LANG_CODE_FR;
exports.LANG_CODE_ID = LANG_CODE_ID;
exports.LANG_CODE_JA = LANG_CODE_JA;
exports.LANG_CODE_PL = LANG_CODE_PL;
exports.LANG_CODE_PT = LANG_CODE_PT;
exports.LANG_CODE_RU = LANG_CODE_RU;
exports.LANG_CODE_TH = LANG_CODE_TH;
exports.LANG_CODE_ZH = LANG_CODE_ZH;
exports.LANG_TAG = LANG_TAG;
exports.LANG_TAG_AR_SA = LANG_TAG_AR_SA;
exports.LANG_TAG_DE_DE = LANG_TAG_DE_DE;
exports.LANG_TAG_EN_US = LANG_TAG_EN_US;
exports.LANG_TAG_ES_ES = LANG_TAG_ES_ES;
exports.LANG_TAG_FR_FR = LANG_TAG_FR_FR;
exports.LANG_TAG_ID_ID = LANG_TAG_ID_ID;
exports.LANG_TAG_JA_JP = LANG_TAG_JA_JP;
exports.LANG_TAG_PL_PL = LANG_TAG_PL_PL;
exports.LANG_TAG_PT_PT = LANG_TAG_PT_PT;
exports.LANG_TAG_RU_RU = LANG_TAG_RU_RU;
exports.LANG_TAG_TH_TH = LANG_TAG_TH_TH;
exports.LANG_TAG_ZH_CN = LANG_TAG_ZH_CN;
exports.LANG_TAG_ZH_HANT = LANG_TAG_ZH_HANT;
exports.LANG_TAG_ZH_HK = LANG_TAG_ZH_HK;
exports.LANG_TAG_ZH_MO = LANG_TAG_ZH_MO;
exports.LANG_TAG_ZH_TW = LANG_TAG_ZH_TW;
exports.REGION_TAG_CN = REGION_TAG_CN;
exports.REGION_TAG_EUR = REGION_TAG_EUR;
exports.REGION_TAG_JP = REGION_TAG_JP;
exports.TOP_DOMAIN = TOP_DOMAIN;
exports.compareLangCode = compareLangCode;
exports.compareLangTag = compareLangTag;
exports.defaultRegionInfo = defaultRegionInfo;
exports.defaultUserRegionInfo = defaultUserRegionInfo;
exports.findInLangs = findInLangs;
exports.formatLangTag = formatLangTag;
exports.getGlobalLang = getGlobalLang;
exports.getI18nConfig = getI18nConfig;
exports.getLang = getLang;
exports.getLangFromCookie = getLangFromCookie;
exports.getLangFromQuery = getLangFromQuery;
exports.getLangUrl = getLangUrl;
exports.getRegionByCoaId = getRegionByCoaId;
exports.getRegionInfo = getRegionInfo;
exports.getServerLang = getServerLang;
exports.getUsedLang = getUsedLang;
exports.getUserRegionInfo = getUserRegionInfo;
exports.getWebOfficeRegionInfo = getWebOfficeRegionInfo;
exports.isAllowedSyncUrl = isAllowedSyncUrl;
exports.isAllowedUrl = isAllowedUrl;
exports.setGlobalLang = setGlobalLang;
exports.setLang = setLang;
exports.setLang2Cookie = setLang2Cookie;
exports.setQueryLang = setQueryLang;
